import apiEndpoints from "./common/apiEndpoints.json";

export const API_ENDPOINTS = apiEndpoints;

export default apiEndpoints;
